module.exports = __webpack_public_path__ + "e4b627e5362c6da9cc4339823b152514.svg";